module.exports = __webpack_public_path__ + "img/CompanieAngajat.152fac31.png";